import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";
import Styles from "./inlineModalDialogButton.lit.scss";

@customElement("eop-inline-modal-dialog-button")
export class EopInlineModalDialogButton extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    @property()
    public label: string;
    @property({attribute: "style"})
    public buttonStyle: string;
    @property({attribute: "size"})
    public buttonSize: string;
    @property({attribute: "disabled-button", type: Boolean})
    public disabledButton: boolean = false;

    public render(): TemplateResult {
        return html`
            <button
                    class="uni-button ${this.buttonStyle} ${this.buttonSize}"
                    @click=${this.openDialog}
                    @keydown=${this.openDialog}
                    ?disabled=${this.disabledButton}
            >
                ${this.label}
            </button>
        `;
    }
}